import { useRegisterStore } from '@/store/register'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useSharePopover } from './useSharePopover'

export function useRegistersShare() {
  const registerStore = useRegisterStore()
  const { getEnergyReading } = storeToRefs(registerStore)

  const availableOptions = computed(() => {
    return getEnergyReading.value.map((sensor) => ({
      id: sensor.index.toString(),
      label: sensor.sensor.name,
      selected: false,
    }))
  })

  const generateSensorCSV = (sensor: any) => {
    let csvContent = ''

    const sensorType = sensor.sensor.sensor_type
    const unit = sensor.sensor.unit_display || 'A'

    csvContent = `Sensor,Canal,Data/Hora UTC-0,Corrente (${unit})\n`

    if (sensor.readings) {
      const fields = sensor.readings

      Object.entries(fields).forEach(([channel, readings]) => {
        const channelReadings = readings as any[]

        channelReadings.forEach((reading) => {
          const timestamp = new Date(reading.t).toISOString()
          const value = reading.v

          csvContent += `${sensor.sensor.name},${channel},${timestamp},${value.toFixed(2)}\n`
        })
      })
    }

    // Criar e baixar o arquivo CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `${sensor.sensor.name}_${new Date().toISOString().split('T')[0]}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const sharePopover = useSharePopover({
    captureSelector: '#registers-view-container',
    captureFileName: 'registers.png',
    onGenerateCSV: () => {
      getEnergyReading.value.forEach((sensor) => {
        if (sharePopover.selectedOptions.value[sensor.index.toString()]) {
          generateSensorCSV(sensor)
        }
      })
    },
  })

  return {
    ...sharePopover,
    availableOptions,
  }
}
